var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h3',[_vm._v(_vm._s(_vm.$t('weCantFindPage')))]),_c('img',{attrs:{"src":require("@/assets/img/404.png"),"alt":""}}),_c('router-link',{attrs:{"to":{name: 'profile'}}},[_vm._v(_vm._s(_vm.$t('backToHome')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }